<form
  class="flex flex-col gap-4 self-stretch"
  [formGroup]="transportFormService.transportForm"
>
  <section class="flex flex-col gap-4 p-6">
    <p class="text-paragraph-med text-primary-900">
      {{
        ("prestation.transportType" | transloco) +
          (
            "categoryType." + transportFormService.transportCategory()
            | transloco
          ).toLowerCase()
      }}
    </p>
    <app-category-selector
      [categoryList]="typeList"
      [(selectedValue)]="type"
      type="list"
    />
  </section>

  @if (transportFormService.displaySubtype) {
    <section class="flex flex-col gap-4 p-6">
      <p class="text-paragraph-med text-primary-900">
        {{ "prestation.transportCarSubType" | transloco }}
      </p>
      <app-category-selector
        [categoryList]="subtypeList"
        [(selectedValue)]="subtype"
        type="list"
      />
    </section>
  }
</form>
